import { toast } from 'react-toastify';
import './custom-toast-styles.css';

export const showSuccess = (message: string) => {
  toast.success(message);
};

export const showError = (message: string) => {
  toast.error(message);
};

export const showWarning = (message: string) => {
  toast.warn(message);
};

export const showInfo = (message: string) => {
  toast.info(message);
};

export const showPromise = (
  promise: Promise<any>,
  {
    pending,
    error,
    success,
  }: { pending: string; error: string; success: string }
) => {
  toast.promise(promise, {
    pending,
    error,
    success,
  });
};
